<template>
  <div class="app-container">
    <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin-bottom: 5px"
      v-if="roles.includes('/notice_template/park_rel_add')"
      >添加</el-button
    >
    <el-button
      type="primary"
      plain
      @click="reset()"
      style="margin-bottom: 5px; float: right"
      >重置</el-button
    >
    <el-button
      type="primary"
      @click="(screen.page = 1),  fetchData()"
      style="margin-bottom: 5px; float: right"
      >搜索</el-button
    >
    <el-select
      style="float: right; margin-right: 10px; width: 200px"
      filterable
      v-model="screen.park_id"
      placeholder="请选择园区"
      v-if="userInfo.park_id == 0"
    >
      <el-option label="全部园区" value=""></el-option>
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in parkList"
        :key="index"
      ></el-option>
    </el-select>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="所属园区" min-width="150">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.park_name }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="210" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleInfo(scope.row)"
            v-if="roles.includes('/notice_template/park_rel_info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/notice_template/park_rel_edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.park_id)"
            v-if="roles.includes('/notice_template/park_rel_del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="czType != 'add' || userInfo.park_id != 0"
            @change="parkChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-for="(item, index) in domains"
          :key="index + item.teamplate_id"
        >
          <span slot="label"
            ><span style="color: red">*</span> 角色与模板{{ index + 1 }}</span
          >
          <el-select
            filterable
            class="w4"
            v-model="item.teamplate_id"
            placeholder="请选择模板"
            :disabled="
              czType == 'see' || userInfo.type == 2 || userInfo.type == 1
            "
            @change="
              (id) => {
                teamplateChange(id, index);
              }
            "
          >
            <el-option
              :disabled="teamplateList.indexOf(item1.id) != -1 ? true : false"
              :label="item1.name"
              :value="item1.id"
              v-for="(item1, index1) in manageList"
              :key="index1"
            ></el-option>
          </el-select>
          <!-- 
          <el-cascader
            collapse-tags
            placeholder="请选择角色"
            :disabled="czType == 'see'"
            v-model="item.system_role_ids"
            :options="roleList"
            :show-all-levels="false"
            :props="{
              multiple: true,
              checkStrictly: true,
              label: 'title',
              value: 'id',
              children: 'nodes',
            }"
            clearable
          ></el-cascader> -->

          <el-select
            v-model="item.system_role_ids"
            filterable
            collapse-tags
            multiple
            reserve-keyword
            @change="(e) => handleSelect(e, index)"
            @visible-change="(e) => selectSeeChannel(e, index)"
            :filter-method="(e) => filter(e, index)"
            placeholder="请选择角色"
            class="mr10 w240"
            :disabled="
              czType == 'see' || userInfo.type == 2 || userInfo.type == 1
            "
          >
            <div
              style="padding: 0 20px; line-height: 34px"
              v-if="czType != 'see'"
            >
              <el-checkbox
                :indeterminate="item.isIndeterminate"
                v-model="item.checkAll"
                @change="(e) => handleCheckAllChange(e, index)"
                >全选</el-checkbox
              >
            </div>
            <el-checkbox-group
              v-model="item.system_role_ids"
              :disabled="
                czType == 'see' || userInfo.type == 2 || userInfo.type == 1
              "
            >
              <el-option
                v-for="(item, index) in roleList"
                :label="item.title"
                :value="item.id"
                :key="index"
              >
                <el-checkbox style="pointer-events: none" :label="item.id">{{
                  item.title
                }}</el-checkbox>
              </el-option>
            </el-checkbox-group>
          </el-select>
          <el-button
            style="margin: 0 0 0 10px"
            v-if="domains.length > 1 && czType != 'see'"
            type="danger"
            @click.prevent="removeDomain(index)"
            >删除</el-button
          >
        </el-form-item>
        <el-form-item v-show="tipShow">
          <span style="color: red">请选择角色与模板</span>
        </el-form-item>
        <el-form-item v-if="userInfo.is_super == 1 && czType != 'see'">
          <el-button type="primary" @click="addDomain">添加</el-button>
        </el-form-item>

        <el-form-item>
          <el-button
            v-if="czType == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <!-- <el-button
            v-if="czType == 'see'"
            type="primary"
            @click="czType = 'edit'"
          >
            编辑
          </el-button> -->
          <el-button
            v-if="czType == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="czType == 'edit' || czType == 'see'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="czType == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { openPark, openRole } from "@/api/index";
import {
  parkRelAdd,
  parkRelEdit,
  parkRelList,
  parkRelDel,
  parkRelInfo,
  get_manage_templates,
} from "@/api/conf";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        is_page: 1,
        page: 1,
        page_size: 15,
        park_id:'',
        is_manage: "",
      },
      total: 0,
      ruleForm: {},
      rules: {
        park_id: [{ required: true, message: "请选择园区", trigger: "blur" }],
        system_role_ids: [{ required: true, message: "请选择角色与模板" }],
      },
      czType: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      manageList: [],
      roleList: [],
      roleListAll: [],
      teamplateList: [],
      domains: [
        {
          system_role_ids: [],
          teamplate_id: "",
          checkAll: false,
          isIndeterminate: false,
        },
      ],
      tipShow: false,
      checkAll: false, //招标阶段 是否全选
      isIndeterminate: false, //全选复选框标识
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    // 下拉框选择事件
    handleSelect(value, index) {
      let filterArray = [];
      let arr = value || [];
      filterArray = this.roleList.filter(function (item) {
        return arr.indexOf(item.id) != -1;
      });
      this.domains[index].checkAll =
        filterArray.length === this.roleList.length;
      this.domains[index].isIndeterminate =
        filterArray.length > 0 && filterArray.length < this.roleList.length;
    },
    // 全选事件
    handleCheckAllChange(val, index) {
      const data = this.roleList.map((item) => {
        return item.id;
      });
      let arr = [];
      let newArray = [];
      if (val == true) {
        arr = Array.from(
          new Set([...this.domains[index].system_role_ids, ...data])
        );
      } else {
        newArray = this.domains[index].system_role_ids.filter(function (item) {
          return data.indexOf(item) == -1;
        });
      }
      this.domains[index].system_role_ids = val ? arr : newArray;
      this.domains[index].isIndeterminate = false;
    },
    // 打开隐藏下拉框事件
    selectSeeChannel(e, index) {
      if (e == false) {
        this.filter("", index);
      }
    },
    //自定搜索，加上防抖
    filter(v, index) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        //对绑定数据赋值
        this.roleList = this.roleListAll.filter((item) => {
          //如果直接包含输入值直接返回true
          if (item.title.indexOf(v) !== -1) return true;
        });
        let filterArray = [];
        let arr = this.domains[index].system_role_ids || [];
        filterArray = this.roleList.filter(function (item) {
          return arr.indexOf(item.title) != -1;
        });
        if (filterArray.length == this.roleList.length) {
          this.domains[index].checkAll = true;
          this.domains[index].isIndeterminate = false;
        } else {
          this.domains[index].checkAll = false;
          if (filterArray.length > 0) {
            this.domains[index].isIndeterminate = true;
          } else {
            this.domains[index].isIndeterminate = false;
          }
        }
      }, 300); // 设置时间
    },

    // 添加园区角色
    addDomain() {
      this.domains.push({ system_role_ids: [], teamplate_id: "" });
    },
    // 删除园区角色
    removeDomain(index) {
      this.teamplateList = [];
      var i = this.teamplateList.findIndex((item) => {
        return item == this.domains[index].teamplate_id;
      });
      if (i != -1) {
        this.teamplateList.splice(i, 1);
      }
      this.roleList.splice(index, 1);
      this.domains.splice(index, 1);
    },
    // 选择模板
    teamplateChange(id, index) {
      this.teamplateList = [];
      this.domains.forEach((item) => {
        if (item.teamplate_id) {
          this.teamplateList.push(item.teamplate_id);
        }
      });
    },
    // 选择园区
    parkChange(id, index) {
      this.getRole(id, index);
    },
    getRole(id) {
      let data = {
        is_page: 2,
        is_tree: 2,
        role_type: 2,
        type: 1,
        park_id: id || "",
      };
      openRole(data).then((res) => {
        this.roleList = res.data.lists;
        this.roleListAll = res.data.lists;
        // this.$set(this.roleList, index, res.data.lists);
      });
    },
    // 获取模板
    getManage() {
      get_manage_templates({ is_manage: 1 }).then((res) => {
        this.manageList = res.data.lists.data;
      });
    },
    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    reset() {
      this.screen = {
        is_manage: "",
        page: 1,
        page_size: 15,
        is_page: 1,
      };
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              var chone = 0;
              let relData = [];
              this.domains.forEach((item) => {
                if (!item.teamplate_id || item.system_role_ids.length < 1) {
                  chone++;
                  return;
                } else {
                  relData.push({
                    system_role_ids: item.system_role_ids.join(","),
                    teamplate_id: item.teamplate_id,
                  });
                }
              });
              if (chone != 0) {
                that.tipShow = true;
                return;
              } else {
                that.tipShow = false;
              }
              let data = {
                park_id: that.ruleForm.park_id,
                template_rel_data: JSON.stringify(relData),
              };
              parkRelEdit(data).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 查看
    handleInfo(val) {
      this.czType = "see";
      this.drawerTitle = "查看";
      this.getInfo(val.park_id);
      this.getRole(val.park_id);
      this.getManage();
      // this.drawer = true;
    },
    // 编辑
    handleEdit(val) {
      this.czType = "edit";
      this.drawerTitle = "编辑";
      // this.ruleForm = val
      this.getInfo(val.park_id);
      this.getRole(val.park_id);
      this.getManage();
      // this.drawer = true;
    },
    // 获取信息
    getInfo(park_id) {
      var that = this;
      parkRelInfo({ park_id: park_id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          park_id: res.data.park_id,
        };
        if (res.data.template_role_data) {
          that.domains = [];
          let list = res.data.template_role_data;
          list.forEach((item, index) => {
            that.domains.push({
              system_role_ids: item.system_role_ids.split(",").map(Number),
              teamplate_id: item.teamplate_id,
            });
          });
          that.teamplateChange();
        }
      });
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          parkRelDel({ park_id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              var chone = 0;
              let relData = [];
              this.domains.forEach((item) => {
                if (!item.teamplate_id || item.system_role_ids.length < 1) {
                  chone++;
                  return;
                } else {
                  relData.push({
                    system_role_ids: item.system_role_ids.join(","),
                    teamplate_id: item.teamplate_id,
                  });
                }
              });
              if (chone != 0) {
                that.tipShow = true;
                return;
              } else {
                that.tipShow = false;
              }
              let data = {
                park_id: that.ruleForm.park_id,
                template_rel_data: JSON.stringify(relData),
              };
              // return
              parkRelAdd(data).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.czType = "add";
      this.ruleForm = {
        park_id: "",
        system_role_ids: [],
        teamplate_id: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
      }
      this.getManage();
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      parkRelList(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}

::v-deep .el-textarea__inner {
  min-height: 100px !important;
}
</style>
